import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import PlatformDashboard from "@/pages/platform/PlatformDashboard";
import Tenants from "@/pages/platform/Tenants";
import TenantDetail from "@/pages/platform/TenantDetail";
import Plans from "@/pages/platform/Plans";
import AdminBilling from "@/pages/platform/Billing";

import Dashboard from "@/pages/tenant/Dashboard";
import Farmers from "@/pages/tenant/Farmers";
import Collections from "@/pages/tenant/Collections";
import RateChart from "@/pages/tenant/RateChart";
import Payments from "@/pages/tenant/Payments";
import Feed from "@/pages/tenant/Feed";
import Reports from "@/pages/tenant/Reports";
import UsersPage from "@/pages/tenant/Users";
import ActivityLogs from "@/pages/tenant/ActivityLogs";
import SettingsPage from "@/pages/tenant/Settings";
import Billing from "@/pages/tenant/Billing";

import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import Terms from "@/pages/legal/Terms";
import Refunds from "@/pages/legal/Refunds";
import Shipping from "@/pages/legal/Shipping";
import Contact from "@/pages/legal/Contact";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "super_admin" ? "/platform" : "/app"} replace />;
}

const platform = (el) => (
  <ProtectedRoute roles={["super_admin"]}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);
const tenant = (el, roles) => (
  <ProtectedRoute roles={roles}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Public legal / policy pages */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/refunds" element={<Refunds />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/contact" element={<Contact />} />

      {/* Platform */}
      <Route path="/platform" element={platform(<PlatformDashboard />)} />
      <Route path="/platform/tenants" element={platform(<Tenants />)} />
      <Route path="/platform/tenants/:id" element={platform(<TenantDetail />)} />
      <Route path="/platform/plans" element={platform(<Plans />)} />
      <Route path="/platform/billing" element={platform(<AdminBilling />)} />

      {/* Tenant */}
      <Route path="/app" element={tenant(<Dashboard />, ["tenant_owner", "operator", "accountant"])} />
      <Route path="/app/farmers" element={tenant(<Farmers />, ["tenant_owner", "operator"])} />
      <Route path="/app/collections" element={tenant(<Collections />, ["tenant_owner", "operator", "accountant"])} />
      <Route path="/app/rate-chart" element={tenant(<RateChart />, ["tenant_owner"])} />
      <Route path="/app/payments" element={tenant(<Payments />, ["tenant_owner", "accountant"])} />
      <Route path="/app/feed" element={tenant(<Feed />, ["tenant_owner"])} />
      <Route path="/app/reports" element={tenant(<Reports />, ["tenant_owner", "accountant"])} />
      <Route path="/app/users" element={tenant(<UsersPage />, ["tenant_owner"])} />
      <Route path="/app/activity" element={tenant(<ActivityLogs />, ["tenant_owner"])} />
      <Route path="/app/settings" element={tenant(<SettingsPage />, ["tenant_owner"])} />
      <Route path="/app/billing" element={tenant(<Billing />, ["tenant_owner"])} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
